<div [hidden]="!appReady" class="container">
  @if (!isMobile) {
    <app-aa-nav-bar />
  }
  @if (isMobile) {
    <app-aa-sidenav></app-aa-sidenav>
  }
  <div class="content-container" [ngClass]="{ 'open-sidenav': isMobile && isSidenavOpen }">
    <div class="content-main">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-timeout></app-timeout>
  <hr class="hr-footer" />
  <div class="privacy-policy">
    <a
      class="privacy-policy-link"
      target="_blank"
      href="https://jetnet.aa.com/sites/policy-center/knowledgearticle/286526/privacy-policy-for-american-airlines-team-members"
    >
      Employee / Contractor Privacy Policy</a
    >
  </div>
  <br />
</div>
<app-aa-spinner [loading]="isLoading"></app-aa-spinner>
<div class="container">
  @if (underMaintenance) {
    <app-maintenance></app-maintenance>
  }
</div>

<app-toaster></app-toaster>

@if (appError) {
  <div class="container">
    <div class="col-lg-12">
      <h1 class="errorText">Error Loading application</h1>
      <p>
        Your session has ended. In order to access your account, you will need to
        <a (click)="signIn()">sign in</a>
        again.
        <br />Please contact the help desk if the problem persists
      </p>
    </div>
  </div>
}

@if (authError) {
  <div class="container">
    <div class="col-lg-12">
      <h1 class="errorText">Not authorized</h1>
      <p>
        You attempted to access content you do not have the authorization to view. If you believe
        this is in error, please contact the CERS administrator.
      </p>
    </div>
  </div>
}

@if (inactiveEmployeeError) {
  <div class="container">
    <div class="col-lg-12">
      <h1 class="errorText">Not authorized</h1>
      <p>{{ errorMessage }}</p>
    </div>
  </div>
}
